var _path, _circle, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0154 3.54839C11.453 2.8172 12.547 2.8172 12.9846 3.54839L21.846 18.3548C22.2836 19.086 21.7366 20 20.8614 20H3.13861C2.26341 20 1.71641 19.086 2.15401 18.3548L11.0154 3.54839Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9998,
    cy: 16.4744,
    r: 1.19995,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8474 8.32833C10.8328 8.15343 10.9708 8.00342 11.1464 8.00342H12.8742C13.0497 8.00342 13.1878 8.15343 13.1732 8.32833L12.7232 13.7283C12.7102 13.8838 12.5803 14.0034 12.4242 14.0034H11.5964C11.4403 14.0034 11.3103 13.8838 11.2974 13.7283L10.8474 8.32833Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.83eb2e1a.svg";
export { ForwardRef as ReactComponent };